import {
  SliceCaseReducers,
  ValidateSliceCaseReducers,
  ActionCreatorWithoutPayload,
  createSlice,
} from '@reduxjs/toolkit';

import { IChatState } from '@sv-support-sdk/chat-shared-types/src/store/chat';

export const initialState: IChatState = {
  id: null,
  hash: '',
  room: '',
  network: false,
  connection: false,
  maintenance: false,
  connectedSupports: [],
  isOpen: false,
  isOnline: false,
  isMaintenance: false,
  isBanned: false,
  onceStarted: false,
  popup: false,
  company: '',
};

const createChatSlice = <T extends IChatState, Reducers extends SliceCaseReducers<T>>({
  name = 'chat',
  initialState,
  reducers,
  resetState,
}: {
  name?: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
  resetState: ActionCreatorWithoutPayload;
}) =>
  createSlice({
    name,
    initialState,
    reducers: {
      setChatNetwork: (state, action) => ({
        ...state,
        network: action.payload,
      }),
      setChatOpen: (state, action) => ({
        ...state,
        isOpen: action.payload,
      }),
      setChatData: (state, action) => ({
        ...state,
        hash: action.payload.hash,
        id: action.payload.chatId,
        room: action.payload.room,
        onceStarted: true,
      }),
      setChatSettings: (state, action) => ({
        ...state,
        isOnline: action.payload.isOnline,
        isMaintenance: action.payload.isMaintenance,
      }),
      addSupport: (state, action) => {
        if (state.connectedSupports.some((el) => el.id === action.payload.id)) return state;

        return {
          ...state,
          connectedSupports: [...state.connectedSupports, action.payload],
        };
      },
      setSupports: (state, action) => ({
        ...state,
        connectedSupports: action.payload,
      }),
      setUserBan: (state, action) => ({
        ...state,
        isBanned: action.payload,
      }),
      setPopup: (state, action) => ({
        ...state,
        popup: action.payload,
      }),
      setChatCompany: (state, action) => ({
        ...state,
        company: action.payload,
      }),
      ...reducers
    },
    extraReducers: (builder) => {
      builder.addCase(resetState, () => {
        return initialState;
      });
    },
  });

export default createChatSlice;
